import { create } from 'zustand';
import fetchWithTenant from '../utils/fetchWithTenant';

const useRaLicenseStore = create((set) => ({
  license: null,
  loading: true,
  error: null,

  fetchLicense: async () => {
    set({ loading: true, error: null });
    try {
      const res = await fetchWithTenant('/api/recording-assurance/license');
      if (res.ok) {
        const data = await res.json();
        set({ license: data.license || null, loading: false });
      } else {
        set({ license: null, loading: false, error: `HTTP ${res.status}` });
      }
    } catch (err) {
      console.error('[RaLicense] Fetch failed:', err);
      set({ license: null, loading: false, error: err.message });
    }
  },

  clearLicense: () => set({ license: null, loading: true, error: null }),
}));

export default useRaLicenseStore;
